"use client";

import { c as _c } from "react/compiler-runtime";
import { AppointmentChecklistComponent } from "../appointment-checklist";
import { shouldShowSidebarChecklist } from "../appointment-checklist-visibility";
import { AppointmentItem } from "../appointment-item";
import { getPatientSidebarAppointmentGroups } from "../appointment-ordering";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import CollapsibleText from "@/components/ui/collapsible-text";
import { EventStatus } from "@/types/enums/event";
import type { EventDetail } from "@/types/event";
import { PatientSidebarSectionSkeleton } from "./section-skeleton";
import { eventQueryOptions } from "@/query/check-in/calendar/event-query";
interface Props {
  patientId: string;
  onStatusChange: (event: EventDetail, status: EventStatus) => void;
  handleViewNote: (eventId?: string, noteId?: string) => void;
}
export default function AppointmentsSection(t0) {
  const $ = _c(21);
  const {
    patientId,
    onStatusChange,
    handleViewNote
  } = t0;
  let t1;
  if ($[0] !== patientId) {
    t1 = eventQueryOptions.searchPatientEvents(patientId, "");
    $[0] = patientId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !!patientId;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      ...t1,
      enabled: t2
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data: events,
    isPending
  } = useQuery(t3);
  let t4;
  if ($[5] !== events) {
    t4 = getPatientSidebarAppointmentGroups(events);
    $[5] = events;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    upcomingAppointments,
    pastAppointments
  } = t4;
  if (isPending) {
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <PatientSidebarSectionSkeleton />;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    return t5;
  }
  let t5;
  if ($[8] !== handleViewNote || $[9] !== onStatusChange || $[10] !== upcomingAppointments) {
    t5 = upcomingAppointments.length > 0 ? <><h4 className="my-2 text-caption font-semibold uppercase tracking-wider text-foreground-secondary">Upcoming Appointments</h4><div className="space-y-4">{upcomingAppointments.map(appointment => <div key={appointment.id}><AppointmentItem appointment={appointment} showDetailedTime={true} showEdit={true} showStatusDropdown={true} onStatusChange={onStatusChange} />{shouldShowSidebarChecklist(appointment, upcomingAppointments) && appointment.status !== EventStatus.CANCELLED && <CollapsibleText text="Show checklist" collapsedText="Hide checklist" className="text-caption"><AppointmentChecklistComponent event={appointment} handleViewNote={handleViewNote} /></CollapsibleText>}</div>)}</div></> : null;
    $[8] = handleViewNote;
    $[9] = onStatusChange;
    $[10] = upcomingAppointments;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== onStatusChange || $[13] !== pastAppointments) {
    t6 = pastAppointments.length > 0 ? <><h4 className="mb-2 mt-4 text-caption font-semibold uppercase tracking-wider text-foreground-secondary">Past Appointments</h4><div className="space-y-4">{pastAppointments.map(appointment_0 => <div key={appointment_0.id}><AppointmentItem appointment={appointment_0} showEdit={true} showStatusDropdown={true} onStatusChange={onStatusChange} /></div>)}</div></> : null;
    $[12] = onStatusChange;
    $[13] = pastAppointments;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== upcomingAppointments.length) {
    t7 = upcomingAppointments.length === 0 && <p className="text-caption text-muted-foreground">No upcoming appointments</p>;
    $[15] = upcomingAppointments.length;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t5 || $[18] !== t6 || $[19] !== t7) {
    t8 = <div>{t5}{t6}{t7}</div>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}